import PayPalExpressButton from './paypalExpressButton';

export default PayPalExpressButton;
